module.exports = __webpack_public_path__ + "static/media/moon.fdd484b7.png";